var GradeLevel = require("lib/academic/GradeLevel");
var StudentMetrics = require("lib/data/StudentMetrics");

class ClassesDisplay extends React.Component {
	render() {
		if (this.props.showTopClasses) {
			var className = "upperClass"
		} else {
			var className = "lowerClass"
		}

		var metric = this.props.metric
		var unitName = StudentMetrics.inverseLookup(metric);
		var adjustedUnitName = StudentMetrics.getUnit(unitName);

		var classes = _.map(this.props.classes, (studentList, index) => {
			if (this.props.showTopClasses) {
				var imgPath = "ranks/school-comp-medal-" + (index + 1) + "-basic.png";
				var rankingImg = (
					<img className="rankImg" src={ dynamicRequire(imgPath) }></img>
				);
			}

			var value = studentList.digest[metric];

			if (!value) {
				var numberValue = 0;
			} else {
				var numberValue = $wr.numberWithCommas(studentList.digest[metric]);
			}

			return (
				<div key={ studentList.id } className={ className }>
					<div className="leftContainer">
						{ rankingImg }
						<p>
							<span>{ studentList.name }</span> <br/>
							<span className="gradeLevel">{ GradeLevel.getName(studentList.grade_level) }</span>
						</p>
						
					</div>
					<div className="rightContainer">
						<span className="unitText">{ numberValue } </span>
						<span>{ adjustedUnitName }</span>	
					</div>
				</div>
			)
		})
		return (
			<div className="topClassesContainer">
				{ classes }
			</div>
		)
	}
}

ClassesDisplay.propTypes = PageStrictPropTypes({
	classes: PropTypes.array,
	metric: PropTypes.string,
	showTopClasses: PropTypes.bool
});

module.exports = ClassesDisplay;


// WEBPACK FOOTER //
// ./modules/components/org/contests/ClassesDisplay.js